import Yup from '_zari/validation/_yup'

const validationSchema = Yup.object().shape({
  direccion: Yup.string().max(300).required(),
  flagAprobacionOrdenCompra: Yup.bool().required(),
  flagCodigoBarra: Yup.bool().required(),
  flagCentroCostoVenta: Yup.bool().required(),
  flagCodigoSunat: Yup.bool().required(),
  flagContabilidad: Yup.bool().required(),
  flagConsumoEnCompra: Yup.bool().required(),
  flagGrifo: Yup.bool().required(),
  flagInventario: Yup.bool().required(),
  flagEnvioAutomatico: Yup.bool().required(),
  flagLoteProductos: Yup.bool().required(),
  flagMarcas: Yup.bool().required(),
  flagOrdenCompraEnVentas: Yup.bool().required(),
  flagPlacaEnVentas: Yup.bool().required(),
  flagTasaPorTarjeta: Yup.bool().required(),
  flagVendedorEnVentas: Yup.bool().required(),
  mailingMail: Yup.string().notRequired(),
  mailingPass: Yup.string().notRequired(),
  mailingService: Yup.string().notRequired(),
  nombreComercial: Yup.string().max(200).notRequired(),
  ubigeo: Yup.string().max(6).notRequired(),
  urbanizacion: Yup.string().max(100).notRequired()
})

export default validationSchema
